export type CheckboxRowProps = {
  label: string;
  checked: boolean;
  onClick: () => void;
};

/** Multi-select checkbox row — used for the status refinement section. */
export function CheckboxRow({ label, checked, onClick }: CheckboxRowProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        "flex w-full items-center gap-2.5 rounded-md px-2.5 py-2.5 text-start text-[13px] transition-colors",
        checked
          ? "border border-[color-mix(in_oklab,var(--accent-500)_25%,var(--card))] bg-[color-mix(in_oklab,var(--accent-500)_8%,var(--card))] font-semibold text-[color:var(--accent-600)]"
          : "border border-transparent font-medium text-[color:var(--text-primary)] hover:bg-[color:var(--background-muted)]",
      ].join(" ")}
    >
      {/* Checkbox indicator */}
      <span
        aria-hidden="true"
        className="inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-[4px] border-[1.5px]"
        style={{
          borderColor: checked ? "var(--accent-500)" : "var(--border-strong)",
          background: checked ? "var(--accent-500)" : "transparent",
        }}
      >
        {checked ? (
          <svg width="9" height="9" viewBox="0 0 12 12" fill="none" stroke="var(--on-accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="2 6 5 9 10 3" />
          </svg>
        ) : null}
      </span>
      {label}
    </button>
  );
}
